import type { MetadataRoute } from "next";
import { site } from "@/content/site";

// Official Next.js App Router manifest convention (app/manifest.ts → /manifest.webmanifest).
export default function manifest(): MetadataRoute.Manifest {
  return {
    name: `${site.name} — AI Agents Agency`,
    short_name: site.name,
    description: site.description,
    start_url: "/",
    display: "standalone",
    background_color: "#020202",
    theme_color: "#020202",
    icons: [
      {
        src: "/icon.png",
        type: "image/png",
        sizes: "any",
      },
    ],
  };
}
